package com.eladfinish.bible.contest.screens.browse.usecases

import com.eladfinish.bible.contest.common.usecases.MakeOtiotPasukSmallerUseCase
import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.data.RefRange
import com.russhwolf.settings.Settings

class GetContentForSedarimModeUseCase(
    private val parseSedarimUseCase: ParseSedarimUseCase,
    private val getSederContentUseCase: GetSederContentUseCase,
    private val prepareChapterContentForDisplayUseCase: PrepareChapterContentForDisplayUseCase,
    private val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase,
    private val renumberOtiotPasukUseCase: RenumberOtiotPasukUseCase,
    private val settings: Settings,
) {

    operator fun invoke(
        bookIndex: Int,
        partIndex: Int,
    ): ChapterData {
        val sedarim = parseSedarimUseCase(bookNumber = bookIndex - 1)
        val sederContent = getSederContentUseCase(
            refRange = sedarim[partIndex - 1].let { RefRange(start = it.start, end = it.end) },
            onlyQri = settings.getBoolean(key = SharedPrefsConstants.ONLY_QRI_SWITCH, defaultValue = true),
        )
            .let(prepareChapterContentForDisplayUseCase::invoke)
            .let(renumberOtiotPasukUseCase::invoke)

        return ChapterData(
            bookIndex = bookIndex,
            chapterIndex = partIndex,
            content = sederContent,
            spannedRangeList = makeOtiotPasukSmallerUseCase(charSequence = sederContent),
        )
    }
}
